import { createFileRoute, redirect } from "@tanstack/react-router";

/** /en/guides has no listing of its own — guides live in the Insights index. */
export const Route = createFileRoute("/en/guides/")({
  beforeLoad: () => {
    throw redirect({ to: "/en/insights", statusCode: 301 });
  },
});
